module.exports = "<div class=\"renderer-container\">\n  <div [ngClass]=\" statusCSS \">\n    <span class=\"centerAlignText\">{{cellValue | uppercase}}</span>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/custom-cell-renderer/custom-cell-renderer.component.html
// module id = ../../../../../src/app/shared/components/custom-cell-renderer/custom-cell-renderer.component.html
// module chunks = main